import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.string.trim.js";
import { __decorate } from "tslib";
import Component from "vue-class-component";
import Vue from "vue";
import { Watch } from "vue-property-decorator";

var Frontali = /*#__PURE__*/function (_Vue) {
  _inherits(Frontali, _Vue);

  var _super = _createSuper(Frontali);

  function Frontali() {
    var _this;

    _classCallCheck(this, Frontali);

    _this = _super.apply(this, arguments); // tipo: string = "";

    _this.selectedSize = "";
    _this.previousSize = "";
    _this.find = "";
    _this.affogatiEnabled = false; // flexType: 'FLEX' | 'NOFLEX' | null = null; // Moved to store

    _this.showSunModelNotAvailable = false;
    _this.clipMode = false;
    return _this;
  }

  _createClass(Frontali, [{
    key: "flexType",
    get: function get() {
      return this.$store.state.flexType;
    },
    set: function set(value) {
      this.$store.commit('setFlexType', value);
    }
  }, {
    key: "frontale",
    get: function get() {
      return this.$store.state.configurator.frontale;
    }
  }, {
    key: "activeFrontalItemCode",
    get: function get() {
      var _this$$store$state$co, _this$$store$state$co2;

      return ((_this$$store$state$co = this.$store.state.configurator) === null || _this$$store$state$co === void 0 ? void 0 : (_this$$store$state$co2 = _this$$store$state$co.frontale) === null || _this$$store$state$co2 === void 0 ? void 0 : _this$$store$state$co2.ItemCode) || "";
    }
  }, {
    key: "calibro",
    get: function get() {
      var parsed = parseInt(this.$store.state.configurator.calibro);
      return isNaN(parsed) ? 0 : parsed;
    }
  }, {
    key: "naso",
    get: function get() {
      var parsed = parseInt(this.$store.state.configurator.naso);
      return isNaN(parsed) ? 0 : parsed;
    }
  }, {
    key: "canViewAffogati",
    get: function get() {
      var _this$$store$state$co3;

      // For non-logged users (guests), always show Moderno/Flex section
      var isGuest = this.$store.getters["configurator/user/isGuest"];

      if (isGuest) {
        return true;
      } // For logged users, check exclusives as before


      var exclusives = (_this$$store$state$co3 = this.$store.state.configurator.user) === null || _this$$store$state$co3 === void 0 ? void 0 : _this$$store$state$co3.exclusives.exclusives;
      return exclusives === null || exclusives === void 0 ? void 0 : exclusives.some(function (item) {
        return (item === null || item === void 0 ? void 0 : item.Exclusive) === "OSIXCUSTOM";
      });
    }
  }, {
    key: "items",
    get: function get() {
      console.log("items", this.$store.state.configurator.frontali.items);
      return this.$store.state.configurator.frontali.items.sort(function (a, b) {
        // Sort by TYPE
        if (a.TYPE === 'TOP' && b.TYPE !== 'TOP') return -1;
        if (a.TYPE !== 'TOP' && b.TYPE === 'TOP') return 1;
        if (a.TYPE === 'NEW' && b.TYPE !== 'NEW') return -1;
        if (a.TYPE !== 'NEW' && b.TYPE === 'NEW') return 1; // If TYPE is the same, sort by ORDERING

        if (a.ORDERING && b.ORDERING) {
          return a.ORDERING - b.ORDERING;
        } // If ORDERING is null, sort by name


        return b.U_THE_MODELLO.localeCompare(a.U_THE_MODELLO);
      });
    }
  }, {
    key: "areThereAffogati",
    get: function get() {
      return this.items.find(function (el) {
        return el.U_THE_TECNOLOGIA == "AFF";
      });
    }
  }, {
    key: "areAffogatoActive",
    get: function get() {
      return this.frontale.U_THE_TECNOLOGIA == "AFF";
    }
  }, {
    key: "filteredItems",
    get: function get() {
      var _this2 = this;

      var query = this.find;

      if (this.clipMode) {
        return this.items.filter(function (i) {
          if (i.U_THE_CUSMODEL !== "CPL" || i.U_TIPO_VSP !== "V") return false;
          var toFind = _this2.find && _this2.find != "" ? i.U_THE_MODELLO.indexOf(query) > -1 : true;
          if (!toFind) return false;
          var areAffogati = _this2.affogatiEnabled ? i.U_THE_TECNOLOGIA == "AFF" : i.U_THE_TECNOLOGIA != "AFF";
          if (!areAffogati) return false;

          if (_this2.affogatiEnabled) {
            var _i$U_THE_MODELLO, _i$U_THE_MODELLO2;

            var isFlexModel = !!((_i$U_THE_MODELLO = i.U_THE_MODELLO) !== null && _i$U_THE_MODELLO !== void 0 && _i$U_THE_MODELLO.includes("FXC") || (_i$U_THE_MODELLO2 = i.U_THE_MODELLO) !== null && _i$U_THE_MODELLO2 !== void 0 && _i$U_THE_MODELLO2.includes("FXSC"));
            if (_this2.flexType === null) return false;
            return _this2.flexType === "FLEX" ? isFlexModel : !isFlexModel;
          }

          return true;
        });
      }

      return this.items.filter(function (i) {
        var _i$U_THE_MODELLO3, _i$U_THE_MODELLO4;

        var areAffogati = _this2.affogatiEnabled ? i.U_THE_TECNOLOGIA == "AFF" : i.U_THE_TECNOLOGIA != "AFF"; // Additional filter for Moderno (AFF): Tipologia Flex / No Flex

        var isFlexModel = ((_i$U_THE_MODELLO3 = i.U_THE_MODELLO) === null || _i$U_THE_MODELLO3 === void 0 ? void 0 : _i$U_THE_MODELLO3.includes("FXC")) || ((_i$U_THE_MODELLO4 = i.U_THE_MODELLO) === null || _i$U_THE_MODELLO4 === void 0 ? void 0 : _i$U_THE_MODELLO4.includes("FXSC"));
        var tipologiaOk = _this2.affogatiEnabled ? _this2.flexType == null ? false // Don't show any models when no flex type is selected in Moderno
        : _this2.flexType == 'FLEX' ? !!isFlexModel : !isFlexModel : true;
        var toFind = _this2.find && _this2.find != "" ? i.U_THE_MODELLO.indexOf(query) > -1 : true;
        var tipo = _this2.tipo == "V" ? i.U_TIPO_VSP == "V" : i.U_TIPO_VSP == "S";
        return i.U_THE_CUSMODEL == "C" && tipo && areAffogati && tipologiaOk && toFind;
      });
    }
  }, {
    key: "canShowClipSection",
    get: function get() {
      var _this$$store$state$co4;

      if (this.tipo !== "V") return false;
      var isGuest = this.$store.getters["configurator/user/isGuest"];
      if (isGuest) return false;
      var extraAccess = (_this$$store$state$co4 = this.$store.state.configurator.user) === null || _this$$store$state$co4 === void 0 ? void 0 : _this$$store$state$co4.extraAccess;
      if (!(extraAccess !== null && extraAccess !== void 0 && extraAccess.includes("OSIX-INCERNIERATI-CLIP"))) return false;
      var affogati = this.affogatiEnabled;
      var flex = this.flexType;
      return this.items.some(function (i) {
        if (i.U_THE_CUSMODEL !== "CPL" || i.U_TIPO_VSP !== "V") return false;

        if (affogati) {
          var _i$U_THE_MODELLO5;

          if (i.U_THE_TECNOLOGIA !== "AFF") return false;
          var isFlex = !!((_i$U_THE_MODELLO5 = i.U_THE_MODELLO) !== null && _i$U_THE_MODELLO5 !== void 0 && _i$U_THE_MODELLO5.includes("FXC"));
          if (flex === "FLEX") return isFlex;
          if (flex === "NOFLEX") return !isFlex;
          return false;
        } else {
          return i.U_THE_TECNOLOGIA !== "AFF";
        }
      });
    }
  }, {
    key: "correspondingFrontalWithClip",
    get: function get() {
      return this.$store.getters["configurator/correspondingFrontalWithClip"];
    }
  }, {
    key: "sizes",
    get: function get() {
      return this.$store.state.configurator.frontali.itemsSizes;
    }
  }, {
    key: "tipo",
    get: function get() {
      return this.$store.state.configurator.glassType;
    },
    set: function set(t) {
      var _this3 = this;

      this.$store.commit("configurator/setLensesType", t, {
        root: true
      }); // If the selected model is sun, check whether the sun version is actually available

      if (t == "S") {
        var filtered = this.items.filter(function (i) {
          return i.U_THE_CUSMODEL == "C" && i.U_TIPO_VSP == "S";
        }); // If the corresponding sun model is not found, show an error to the user and bring him back to sight models

        if (filtered.find(function (f) {
          return f.U_THE_MODELLO == _this3.frontale.U_THE_MODELLO.replaceAll("C", "SC");
        }) == undefined) {
          this.showSunModelNotAvailable = true;
          return;
        }
      }

      this.$store.commit("setLenteDx", null);
      this.$store.commit("setLenteSx", null);
      this.$store.commit("resetLentiVista");
      this.$store.commit("configurator/lenti/resetCfgLenteVistaDx");
      this.$store.commit("configurator/lenti/resetCfgLenteVistaSx");
      this.$store.commit("resetRowNotes");
    }
  }, {
    key: "itemSizes",
    get: function get() {
      var front = this.$store.state.configurator.frontale;

      if (front && this.sizes.length > 0) {
        return this.sizes.filter(function (s) {
          return s.ItemCode == front.ItemCode;
        });
      }

      return [];
    }
  }, {
    key: "activeTemple",
    get: function get() {
      return this.$store.state.activetemple;
    },
    set: function set(t) {
      this.$store.commit("setActiveTemple", t);
    }
  }, {
    key: "checkErrorsFrontali",
    get: function get() {
      return this.$store.getters["configurator/frontali/checkErrors"];
    }
  }, {
    key: "frontaliSizeError",
    get: function get() {
      return this.checkErrorsFrontali.find(function (el) {
        return el.label == "size";
      });
    }
  }, {
    key: "asianFitting",
    get: function get() {
      return this.$store.state.configurator.asianFitting;
    },
    set: function set(af) {
      this.$store.commit("configurator/setAsianFitting", af);
    }
  }, {
    key: "tintaUnita",
    get: function get() {
      return this.$store.state.tintaUnita;
    }
  }, {
    key: "finitura",
    get: function get() {
      return this.$store.state.configurator.finitura;
    }
  }, {
    key: "colore",
    get: function get() {
      return this.$store.state.configurator.colore;
    }
  }, {
    key: "coloreAste",
    get: function get() {
      return this.$store.state.configurator.coloreAste;
    }
  }, {
    key: "temples",
    get: function get() {
      return this.$store.getters.filteredTemples;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this$frontale,
          _this4 = this;

      this.affogatiEnabled = this.$store.state.affogatiEnabled;
      this.$store.commit('setCurrentSubline', this.frontale.U_THE_SOTTOLINEA || null);
      this.clipMode = ((_this$frontale = this.frontale) === null || _this$frontale === void 0 ? void 0 : _this$frontale.U_THE_CUSMODEL) === "CPL"; // flexType remains null to force user selection (now in store)
      // Listen for login reset event

      this.$root.$on('forceClassicoSelection', function () {
        _this4.affogatiEnabled = false;
      });
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      // Clean up event listener
      this.$root.$off('forceClassicoSelection');
    }
  }, {
    key: "setSize",
    value: function setSize(s) {
      this.$store.commit("configurator/setSize", s);
    }
  }, {
    key: "setFrontal",
    value: function setFrontal(f) {
      var _this5 = this;

      var hadClip = this.$store.state.configurator.clip != null;
      this.$store.commit("configurator/setFrontal", f);
      var subline = f.U_THE_SOTTOLINEA || null;

      if (!subline && f.U_THE_CUSMODEL === 'CPL') {
        var _this$$store$state$co5, _this$$store$state$co6;

        var correspondingNonCpl = (_this$$store$state$co5 = this.$store.state.configurator.frontali) === null || _this$$store$state$co5 === void 0 ? void 0 : (_this$$store$state$co6 = _this$$store$state$co5.items) === null || _this$$store$state$co6 === void 0 ? void 0 : _this$$store$state$co6.find(function (item) {
          return item.U_THE_CUSMODEL === 'C' && f.U_THE_MODELLO.includes(item.U_THE_MODELLO);
        });
        subline = (correspondingNonCpl === null || correspondingNonCpl === void 0 ? void 0 : correspondingNonCpl.U_THE_SOTTOLINEA) || null;
      }

      var tipoSublines = ['TIPO_U', 'TIPO_V', 'TIPO_N', 'TIPO_M'];

      if (f.U_THE_TECNOLOGIA === 'AFF' && (!subline || !tipoSublines.includes(subline))) {
        var _this$$store$state$co7, _this$$store$state$co8;

        var baseModelName = f.U_THE_MODELLO.replace('FXSC', 'SC').replace('FXC', 'C');
        var baseModel = (_this$$store$state$co7 = this.$store.state.configurator.frontali) === null || _this$$store$state$co7 === void 0 ? void 0 : (_this$$store$state$co8 = _this$$store$state$co7.items) === null || _this$$store$state$co8 === void 0 ? void 0 : _this$$store$state$co8.find(function (item) {
          return item.U_THE_MODELLO === baseModelName && item.U_THE_TECNOLOGIA === 'AFF';
        });
        subline = (baseModel === null || baseModel === void 0 ? void 0 : baseModel.U_THE_SOTTOLINEA) || subline;
      }

      this.$store.commit('setCurrentSubline', subline);

      if (this.clipMode && hadClip) {
        var newClip = this.$store.getters["configurator/correspondingClip"];
        this.$store.commit("configurator/setClip", newClip || null);
      }

      if (f.U_THE_TECNOLOGIA === "AFF") {
        this.$store.commit("configurator/setAsianFitting", false);
      }

      if (this.$store.state.affogatiEnabled != this.affogatiEnabled) {
        var _this$temples;

        // Set affogati abilitati o no
        this.$store.commit("setAffogatiEnabled", this.affogatiEnabled); // Reset materiale

        this.$store.commit("configurator/setTemplesMaterial", "PL"); // Reset abbellitore

        this.$store.commit("configurator/setAbbellitore", null);
        var defColor = (_this$temples = this.temples) === null || _this$temples === void 0 ? void 0 : _this$temples.find(function (temple) {
          return (temple.U_THE_COLORE == "EP0001" || temple.U_THE_COLORE == "PL0001") && temple.U_THE_LUNGASTA == (_this5.coloreAste ? _this5.coloreAste.U_THE_LUNGASTA : "145");
        }); // Reset colors

        this.$store.dispatch("configurator/frontali/setColor", "EP0001");
        this.$store.dispatch("configurator/aste/setColor", defColor === null || defColor === void 0 ? void 0 : defColor.ItemCode); // Reset finishing to Shiny

        this.$store.commit("configurator/setFinishing", "S");
        this.$store.commit("configurator/setTemplesFinishing", "S");
      } else if (this.$store.state.affogatiEnabled) {
        var _defColor = this.temples.find(function (temple) {
          return (temple.U_THE_COLORE == "EP0001" || temple.U_THE_COLORE == "PL0001") && temple.U_THE_LUNGASTA == (_this5.coloreAste ? _this5.coloreAste.U_THE_LUNGASTA : "145");
        });

        var corresponding = this.temples.find(function (temple) {
          return temple.U_THE_COLORE == (_this5.tintaUnita ? _this5.colore.U_THE_COLORE : _this5.coloreAste.U_THE_COLORE) && temple.U_THE_LUNGASTA == (_this5.coloreAste ? _this5.coloreAste.U_THE_LUNGASTA : "145");
        });

        if (corresponding) {
          this.$store.commit("configurator/setTemplesColor", corresponding);
          this.$store.commit("configurator/setTemplesFinishing", this.finitura);
        } else {
          // Reset colors
          this.$store.dispatch("configurator/frontali/setColor", "EP0001");
          this.$store.dispatch("configurator/aste/setColor", _defColor === null || _defColor === void 0 ? void 0 : _defColor.U_THE_COLORE); // Reset finishing to Shiny

          this.$store.commit("configurator/setFinishing", "S");
          this.$store.commit("configurator/setTemplesFinishing", "S");
        }
      } else {
        // Non-affogati, same affogati state (e.g. switching between C and CPL frames):
        // check if current temple still belongs to the new subline; if not, reset to a valid default.
        var currentColoreAste = this.coloreAste;

        if (currentColoreAste) {
          var currentTempleValid = this.temples.find(function (t) {
            return t.ItemCode === currentColoreAste.ItemCode;
          });

          if (!currentTempleValid) {
            var _this$temples2, _this$temples3, _this$temples4;

            var preferredSize = currentColoreAste.U_THE_LUNGASTA || "145";

            var _defColor2 = ((_this$temples2 = this.temples) === null || _this$temples2 === void 0 ? void 0 : _this$temples2.find(function (t) {
              return (t.U_THE_COLORE == "EP0001" || t.U_THE_COLORE == "PL0001") && t.U_THE_LUNGASTA == preferredSize;
            })) || ((_this$temples3 = this.temples) === null || _this$temples3 === void 0 ? void 0 : _this$temples3.find(function (t) {
              return t.U_THE_COLORE == "EP0001" || t.U_THE_COLORE == "PL0001";
            })) || ((_this$temples4 = this.temples) === null || _this$temples4 === void 0 ? void 0 : _this$temples4[0]);

            if (_defColor2) {
              this.$store.dispatch("configurator/aste/setColor", _defColor2.ItemCode);
            }
          }
        }
      }
    }
  }, {
    key: "setSunLensesModel",
    value: function setSunLensesModel(l) {
      this.$store.commit("configurator/setSunLensesModel", l);
    }
  }, {
    key: "closeDialogErroreLenti",
    value: function closeDialogErroreLenti() {
      this.$store.commit("openCloseDialogErroreLenti", false);
    }
  }, {
    key: "resetPreviousLenses",
    value: function resetPreviousLenses() {
      this.$store.commit("configurator/setOftLensesDxModel", this.$store.state.lenteDx);
      this.$store.commit("configurator/setOftLensesSxModel", this.$store.state.lenteSx);
    }
  }, {
    key: "clearLenses",
    value: function clearLenses() {
      this.$store.commit("setLenteSx", null);
      this.$store.commit("setLenteDx", null);
    }
  }, {
    key: "clipModeChanged",
    value: function clipModeChanged(newV) {
      var _this$$store$state$co9;

      if (newV) {
        var cplFrontal = this.correspondingFrontalWithClip;

        if (cplFrontal) {
          this.setFrontal(cplFrontal);
        }
      } else if (((_this$$store$state$co9 = this.$store.state.configurator.frontale) === null || _this$$store$state$co9 === void 0 ? void 0 : _this$$store$state$co9.U_THE_CUSMODEL) === "CPL") {
        var cFrontal = this.$store.getters["configurator/correspondingFrontalWithoutClip"];

        if (cFrontal) {
          this.setFrontal(cFrontal);
        }

        this.$store.commit("configurator/resetClip");
      }
    }
  }, {
    key: "canShowClipSectionChanged",
    value: function canShowClipSectionChanged(newV) {
      if (!newV && this.clipMode) {
        this.clipMode = false;
      }
    }
  }, {
    key: "affogatiEnabledChanged",
    value: function affogatiEnabledChanged(newV) {
      this.$store.commit("setAffogatiEnabled", newV);
      this.$store.commit("configurator/setAsianFitting", false); // A ogni cambio Classico/Moderno l'abbellitore torna al Tipo A.

      this.$store.commit("configurator/setAbbellitore", null); // When switching to Moderno (AFF), keep flexType null to force user selection
      // When switching to Classico, reset Tipologia selection

      if (!newV) {
        this.$store.commit("setFlexType", null);
      }
    }
  }, {
    key: "flexTypeChanged",
    value: function flexTypeChanged(newVal) {
      var _this6 = this;

      if (!newVal || !this.frontale || !this.affogatiEnabled) {
        return;
      } // Find corresponding model based on current model and new flex type


      var currentModel = this.frontale.U_THE_MODELLO;
      var isCurrentlyFlex = (currentModel === null || currentModel === void 0 ? void 0 : currentModel.includes("FXC")) || (currentModel === null || currentModel === void 0 ? void 0 : currentModel.includes("FXSC")); // If we're already on the correct type, no need to change

      if (newVal === 'FLEX' && isCurrentlyFlex || newVal === 'NOFLEX' && !isCurrentlyFlex) {
        return;
      } // Find the corresponding model


      var targetModel;

      if (newVal === 'FLEX') {
        // Convert to Flex version
        if (currentModel.includes("SC")) {
          // Sole model: replace SC with FXSC
          targetModel = currentModel.replace("SC", "FXSC");
        } else {
          // Vista model: replace C with FXC
          targetModel = currentModel.replace(/C$/, "FXC");
        }
      } else {
        // Convert to No Flex version
        if (currentModel.includes("FXSC")) {
          // Sole Flex model: replace FXSC with SC
          targetModel = currentModel.replace("FXSC", "SC");
        } else if (currentModel.includes("FXC")) {
          // Vista Flex model: replace FXC with C
          targetModel = currentModel.replace("FXC", "C");
        }
      } // Find the model in the items array


      var correspondingModel = this.items.find(function (item) {
        return item.U_THE_MODELLO === targetModel && item.U_TIPO_VSP === _this6.tipo && item.U_THE_TECNOLOGIA === "AFF";
      });

      if (correspondingModel) {
        this.setFrontal(correspondingModel); // Force update of default temples for the new model

        this.updateDefaultTemplesForModel(correspondingModel);
      }
    }
  }, {
    key: "calibroChanged",
    value: function calibroChanged(newV) {
      // @ts-ignore
      // eslint-disable-next-line no-undef
      gtag("event", "setMisure", {
        event_category: "frontale",
        event_label: this.frontale.U_THE_MODELLO + " - " + newV + "/" + this.naso
      });

      if (newV == "") {
        this.selectedSize = "";
      }
    }
  }, {
    key: "sizeChanged",
    value: function sizeChanged(newV) {
      var _this7 = this;

      var s = this.itemSizes.filter(function (s) {
        return s.id == newV;
      });

      if (s.length > 0) {
        var foundSize = this.sizes.find(function (el) {
          return el.U_THE_MODELLO == _this7.frontale.U_THE_MODELLO && el.size_eye == _this7.calibro.toFixed(2) && el.size_bridge == _this7.naso.toFixed(2);
        });
        this.previousSize = foundSize == undefined ? null : foundSize.id;
        this.setSize(s[0]);
      } else {
        this.$store.commit("configurator/setSize", {
          size_eye: "",
          size_bridge: ""
        });
      }
    }
  }, {
    key: "onActiveFrontalItemCodeChanged",
    value: function () {
      var _onActiveFrontalItemCodeChanged = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newItemCode) {
        var _this$$store$state$co10;

        var itemCode, line;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                itemCode = String(newItemCode || "").trim();

                if (itemCode) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                line = ((_this$$store$state$co10 = this.$store.state.configurator) === null || _this$$store$state$co10 === void 0 ? void 0 : _this$$store$state$co10.overrideLinea) || process.env.VUE_APP_CONFIG_IDENTIFIER || "";
                _context.prev = 4;
                _context.next = 7;
                return this.$store.dispatch("configurator/user/refreshClientEngravingConfigurations", {
                  line: line,
                  itemCode: itemCode
                });

              case 7:
                _context.next = 11;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](4);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 9]]);
      }));

      function onActiveFrontalItemCodeChanged(_x) {
        return _onActiveFrontalItemCodeChanged.apply(this, arguments);
      }

      return onActiveFrontalItemCodeChanged;
    }()
  }, {
    key: "tipoChanged",
    value: function tipoChanged(newVal) {
      var _this8 = this;

      this.setSunLensesModel(null);

      if (newVal === "S" && this.clipMode) {
        this.clipMode = false;
      } // Enhanced logic to handle Flex/No Flex models when switching Vista/Sole


      var currentModel = this.frontale.U_THE_MODELLO;
      var isCurrentlyFlex = (currentModel === null || currentModel === void 0 ? void 0 : currentModel.includes("FXC")) || (currentModel === null || currentModel === void 0 ? void 0 : currentModel.includes("FXSC"));
      var targetModel;

      if (newVal === "S") {
        // Switching to Sole
        if (isCurrentlyFlex) {
          // Current is Flex Vista, target is Flex Sole
          targetModel = currentModel.replace("FXC", "FXSC");
        } else {
          // Current is regular Vista, target is regular Sole
          targetModel = currentModel.replace(/C$/, "SC");
        }
      } else {
        // Switching to Vista
        if (currentModel.includes("FXSC")) {
          // Current is Flex Sole, target is Flex Vista
          targetModel = currentModel.replace("FXSC", "FXC");
        } else if (currentModel.includes("SC")) {
          // Current is regular Sole, target is regular Vista
          targetModel = currentModel.replace("SC", "C");
        }
      } // Find the specific target model first


      var correspondingModel = this.items.find(function (i) {
        return i.U_THE_MODELLO === targetModel && i.U_TIPO_VSP === newVal;
      }); // If specific model not found, fall back to original logic

      if (!correspondingModel) {
        var m = this.items.filter(function (i) {
          return i.U_THE_MODELLO.replace("FXSC", "").replace("FXC", "").replace("SC", "").replace("C", "") == _this8.frontale.U_THE_MODELLO.replace("FXSC", "").replace("FXC", "").replace("SC", "").replace("C", "") && i.U_TIPO_VSP == newVal;
        });

        if (m.length > 0) {
          correspondingModel = m[0];
        }
      }

      if (correspondingModel) {
        this.setFrontal(correspondingModel); // Force update of default temples for the new model

        this.updateDefaultTemplesForModel(correspondingModel);
      }
    } // Helper method to find and set corresponding size

  }, {
    key: "findAndSetCorrespondingSize",
    value: function findAndSetCorrespondingSize(model) {
      var _this9 = this;

      if (this.calibro && this.naso) {
        // Get sizes for the new model
        var modelSizes = this.sizes.filter(function (size) {
          return size.ItemCode === model.ItemCode;
        }); // Look for exact size match

        var correspondingSize = modelSizes.find(function (size) {
          return parseInt(size.size_eye) === _this9.calibro && parseInt(size.size_bridge) === _this9.naso;
        });

        if (correspondingSize) {
          this.selectedSize = correspondingSize.id;
          this.setSize(correspondingSize);
        } else {
          // No corresponding size found, clear selection
          this.selectedSize = "";
          this.$store.commit("configurator/setSize", {
            size_eye: "",
            size_bridge: ""
          });
        }
      }
    } // Helper method to update default temples when model changes

  }, {
    key: "updateDefaultTemplesForModel",
    value: function updateDefaultTemplesForModel(model) {
      var _this$temples5, _this$temples6, _this$temples7;

      // Force refresh of temples by updating the subline
      this.$store.commit('setCurrentSubline', model.U_THE_SOTTOLINEA || null); // Find and set default temple color

      var preferredSize = this.coloreAste ? this.coloreAste.U_THE_LUNGASTA : "145";
      var defColor = ((_this$temples5 = this.temples) === null || _this$temples5 === void 0 ? void 0 : _this$temples5.find(function (temple) {
        return (temple.U_THE_COLORE == "EP0001" || temple.U_THE_COLORE == "PL0001") && temple.U_THE_LUNGASTA == preferredSize;
      })) || ((_this$temples6 = this.temples) === null || _this$temples6 === void 0 ? void 0 : _this$temples6.find(function (temple) {
        return temple.U_THE_COLORE == "EP0001" || temple.U_THE_COLORE == "PL0001";
      })) || ((_this$temples7 = this.temples) === null || _this$temples7 === void 0 ? void 0 : _this$temples7[0]);

      if (defColor) {
        this.$store.dispatch("configurator/aste/setColor", defColor.ItemCode);
      } // Keep temple finishing aligned with the active front finishing.


      this.$store.commit("configurator/setTemplesFinishing", this.finitura);
    }
  }]);

  return Frontali;
}(Vue);

__decorate([Watch("clipMode")], Frontali.prototype, "clipModeChanged", null);

__decorate([Watch("canShowClipSection")], Frontali.prototype, "canShowClipSectionChanged", null);

__decorate([Watch("affogatiEnabled")], Frontali.prototype, "affogatiEnabledChanged", null);

__decorate([Watch("flexType")], Frontali.prototype, "flexTypeChanged", null);

__decorate([Watch("calibro")], Frontali.prototype, "calibroChanged", null);

__decorate([Watch("selectedSize")], Frontali.prototype, "sizeChanged", null);

__decorate([Watch("activeFrontalItemCode", {
  immediate: true
})], Frontali.prototype, "onActiveFrontalItemCodeChanged", null);

__decorate([Watch("tipo")], Frontali.prototype, "tipoChanged", null);

Frontali = __decorate([Component({})], Frontali);
export default Frontali;